export default {
    props: ['count', 'cart_items'],

    methods: {
      checkforShippingProtection() {
        if (this.cart_items && Array.isArray(this.cart_items)) {
          return this.cart_items.some(item => item.variant_id === 44191634292983) ? this.count - 1 : this.count;
        }
        return this.count;
      },
      updateNavCartCount() {
        const cartCountElement = document.querySelector('.header__cart-count.bubble-count');
        if (cartCountElement) {
          cartCountElement.textContent = this.checkforShippingProtection();
        }
      }
    
    },
    watch: {
      count: {
        immediate: true,
        handler(newValue, oldValue) {
          this.updateNavCartCount();
        }
      }
    },
    template: `
      <button class="counter_vue_cart">
        {{ checkforShippingProtection() }}
      </button>
      `
  }